import {cn} from '../lib/cn';

export type RatingProgressProps = {
  label: string;
  score: number;
  maxScore?: number;
  className?: string;
};

const getRatingColor = (score: number, maxScore: number): string => {
  const percentage = (score / maxScore) * 100;

  if (percentage === 0) return 'var(--chekin-rating-0)';
  if (percentage <= 20) return 'var(--chekin-rating-1)';
  if (percentage <= 40) return 'var(--chekin-rating-2)';
  if (percentage <= 50) return 'var(--chekin-rating-3)';
  if (percentage <= 60) return 'var(--chekin-rating-4)';
  if (percentage <= 80) return 'var(--chekin-rating-5)';
  return 'var(--chekin-rating-6)';
};

export function RatingProgress({
  label,
  score,
  maxScore = 10,
  className,
}: RatingProgressProps) {
  const percentage = Math.max(0, Math.min(100, (score / maxScore) * 100));
  const color = getRatingColor(score, maxScore);

  return (
    <div
      className={cn(
        'flex w-full min-w-[160px] flex-col items-start justify-center',
        className,
      )}
    >
      <div className="flex w-full items-start justify-between text-sm font-medium leading-6">
        <p className="min-w-0 flex-1">{label}</p>
        <p className="shrink-0 whitespace-pre">{score.toFixed(1)}</p>
      </div>

      <div className="relative w-full">
        <div className="h-1.5 w-full rounded-[24px] bg-[var(--chekin-color-gray-3)]" />
        <div
          className="absolute left-0 top-0 h-1.5 rounded-[24px] transition-all duration-300 ease-out"
          style={{
            width: `${percentage}%`,
            backgroundColor: color,
          }}
        />
      </div>
    </div>
  );
}
